import React, { useContext, useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../context/theme";
import { IMAGE_URL } from "../services/api-url";
import axios from "axios";

const SEARCH_API_URL = "https://site-api.thecarbonshield.com/api/web/buildings/search";

const Setting = [
    // {
    //     title: "Change Password",
    //     icon: "icon-key",
    //     to: "/change-password",
    // },
    {
        title: "Logout",
        icon: "icon-log-out",
        to: "/login",
    },
];

function TopNavbar() {
    const { userInfo, MiniSidebar, setMiniSidebar, setAuth } = useContext(UserContext);
    const navigate = useNavigate();
    const [isActive, setActive] = useState("false");

    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const searchRef = useRef(null);
    const debounceTimer = useRef(null);

    const searchBuildings = useCallback(async (query) => {
        if (!query || query.trim().length < 2) {
            setSearchResults([]);
            setShowSearchDropdown(false);
            return;
        }
        setSearchLoading(true);
        try {
            const res = await axios.get(SEARCH_API_URL, { params: { q: query.trim() } });
            setSearchResults(res.data || []);
            setShowSearchDropdown(true);
        } catch (err) {
            console.error("Search failed:", err);
            setSearchResults([]);
        } finally {
            setSearchLoading(false);
        }
    }, []);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        debounceTimer.current = setTimeout(() => searchBuildings(value), 300);
    };

    const handleResultClick = (result) => {
        setShowSearchDropdown(false);
        setSearchQuery("");
        setSearchResults([]);
        navigate(`/product/view/${result.parentBuildingId}`);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setShowSearchDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const ToggleClass = () => {
        setActive(!isActive);
    };
    function ToggleSidebar() {
        setMiniSidebar(!MiniSidebar);
    }
    const Logout = () => {
        localStorage.removeItem("token");
        setAuth(false);
        navigate('/login')
    };

    return (
        <nav className="navbar header-navbar">
            <div className="navbar-wrapper w-100">
                <div className="navbar-container container-fluid">
                    <div className="row w-100 align-items-center">
                        <div className="col-auto">
                            <div className="nav-left mr-auto">
                                <div className="menu-hamburger ml-1 fs-5">
                                    <span className="icon-menu" onClick={() => ToggleSidebar()}></span>
                                    <span className="icon-x" onClick={() => ToggleSidebar()}></span>
                                </div>
                                <div className="slideUp_header  ml-1 fs-5">
                                    <span className="icon-arrow-up"></span>
                                </div>
                            </div>
                        </div>
                        <div className="col" ref={searchRef} style={{ position: "relative", maxWidth: "480px" }}>
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                background: "#f8fbfb",
                                border: "1px solid #adadad",
                                borderRadius: ".375rem",
                                boxShadow: "1px 1px 1px #282c344a",
                                padding: "0 .75rem",
                                height: "38px",
                            }}>
                                {searchLoading ? (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        style={{ color: "#1C6B3A", marginRight: ".6rem", width: "14px", height: "14px" }}
                                    />
                                ) : (
                                    <i className="fas fa-search" style={{ color: "#1C6B3A", marginRight: ".6rem", fontSize: ".875rem" }}></i>
                                )}
                                <input
                                    type="text"
                                    placeholder="Search buildings by address"
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    onFocus={() => searchResults.length > 0 && setShowSearchDropdown(true)}
                                    style={{
                                        flex: 1,
                                        border: "none",
                                        outline: "none",
                                        background: "transparent",
                                        fontSize: ".875rem",
                                        color: "#212529",
                                        padding: ".375rem 0",
                                    }}
                                />
                                {searchQuery && (
                                    <i
                                        className="fas fa-times"
                                        onClick={() => {
                                            setSearchQuery("");
                                            setSearchResults([]);
                                            setShowSearchDropdown(false);
                                        }}
                                        style={{ color: "#6c757d", cursor: "pointer", fontSize: ".75rem", marginLeft: ".5rem" }}
                                    ></i>
                                )}
                            </div>
                            {showSearchDropdown && searchResults.length > 0 && (
                                <div style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "0",
                                    right: "0",
                                    zIndex: 1050,
                                    maxHeight: "320px",
                                    overflowY: "auto",
                                    background: "#fff",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "0 0 .375rem .375rem",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    marginTop: "2px",
                                }}>
                                    {searchResults.map((result) => (
                                        <div
                                            key={result._id}
                                            onClick={() => handleResultClick(result)}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: ".5rem .75rem",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #f0f0f0",
                                                fontSize: ".875rem",
                                                transition: "background .15s ease",
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.background = "#f2f7fb"}
                                            onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                                        >
                                            <div>
                                                <div style={{ fontWeight: 600, color: "#212529" }}>{result.address}</div>
                                                <small style={{ color: "#6c757d" }}>BBL: {result.bbl}</small>
                                            </div>
                                            <i className="fas fa-chevron-right" style={{ color: "#1C6B3A", fontSize: ".7rem" }}></i>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {showSearchDropdown && searchQuery.trim().length >= 2 && !searchLoading && searchResults.length === 0 && (
                                <div style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "0",
                                    right: "0",
                                    zIndex: 1050,
                                    background: "#fff",
                                    border: "1px solid #dee2e6",
                                    borderRadius: "0 0 .375rem .375rem",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                    marginTop: "2px",
                                    textAlign: "center",
                                    padding: ".75rem",
                                    color: "#6c757d",
                                    fontSize: ".875rem",
                                }}>
                                    No buildings found
                                </div>
                            )}
                        </div>
                        <div className="col-auto ms-auto">
                            <ul className="nav-right d-flex align-items-center justify-content-end mb-0">
                                <li className="user-profile header-notification">
                                    <div className="dropdown-primary dropdown">
                                        <div className="dropdown-toggle" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                            {userInfo.userImage?.path ? <img src={`${IMAGE_URL}${userInfo.userImage?.path}`} className="img-radius img-fluid" alt="User-Profile" /> : <span className="cs-avatar" aria-label="User"><svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><g fill="#0F3020"><rect x="9" y="13" width="8" height="27" /><rect x="25" y="16" width="7" height="24" /></g><g fill="#1C6B3A"><rect x="3" y="21" width="7" height="19" /><rect x="18" y="19" width="7" height="21" /><rect x="33" y="23" width="5" height="17" /></g><g fill="#38A55A"><rect x="13" y="26" width="6" height="14" /><rect x="30" y="27" width="5" height="13" /></g><g fill="#B6E86A"><rect className="cs-tw" x="11" y="17" width="1.6" height="2" /><rect x="27" y="20" width="1.6" height="2" opacity="0.5" /><rect className="cs-tw" x="20" y="23" width="1.6" height="2" style={{ animationDelay: "1.1s" }} /><rect x="5" y="25" width="1.6" height="2" opacity="0.55" /><rect className="cs-tw" x="14.6" y="30" width="1.6" height="2" style={{ animationDelay: "0.6s" }} /></g></svg></span>}
                                            <span>{userInfo?.firstName} {userInfo?.lastName}</span>
                                            <i className="icon-chevron-down cs-caret"></i>
                                        </div>
                                        <ul className="show-notification dropdown-menu-end profile-notification dropdown-menu" data-dropdown-in="fadeIn" data-dropdown-out="fadeOut" aria-labelledby="dropdownMenuLink">

                                                    <li>
                                                        <Link to="/admin/profile">
                                                            <i className="icon-user"></i> Profile
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/change-password">
                                                            <i className="fa fa-key"></i> Change Password
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <a onClick={() => Logout()} style={{"cursor": "pointer"}}>
                                                            <i className="icon-log-out" ></i> Logout
                                                        </a>
                                                    </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default TopNavbar;
